export default function Information() {
  return (
    <>
      <div class='container py-4 px-6 mx-0 min-w-full bg-gray-50 shadow rounded-xl border dark:bg-gray-800 dark:border-gray-700'>
        <div class='m-3'>
          <p class='font-medium text-lg text-center dark:text-white'>Data Visualization Uploads</p>
          <p class='mt-1 dark:text-gray-300'>
            Data visualization uploads provide a convenient way for contributors to present their data in a visual format.
            By uploading files in the required format, contributors can create engaging and informative visualizations.
            This information page will guide you through the process of data visualization uploads and explain important aspects to consider.
          </p>

          <p class='font-medium text-lg text-center mt-3 dark:text-white'>Process Overview</p>
          <ol className="dark:text-gray-300">
            <li class='mt-1'>
              <strong>Title and Description:</strong> To begin, contributors will provide a title and description for their data.
              This helps provide context and understanding for viewers who interact with the visualization.
            </li>
            <li class='mt-1'>
              <strong>File Selection:</strong> The contributor selects the file they want to visualize.
              It is crucial to ensure that the file is in the correct format specified for the chosen type of visualization.
              Different visualization tools or platforms may have specific file format requirements.
            </li>
            <li class='mt-1'>
              <strong>Formatting Assistance:</strong> In some cases, visualization options may include templates that contributors can utilize to help format their data correctly.
              These templates are designed to streamline the process and ensure the data is presented effectively.
            </li>
          </ol>

          <p class='font-medium text-lg text-center mt-3 dark:text-white'>Independence from Projects:</p>
          <p class='mt-1 dark:text-gray-300'>
            It's important to note that visualization uploads are separate from the projects they are attached to.
            This means that contributors have the flexibility to edit or delete their visualization uploads at any time, independent of the project they are associated with.
            This independence allows contributors to refine and update their visualizations as needed without impacting the overall project structure.
          </p>

          <p class='font-medium text-lg text-center mt-3 dark:text-white'>Benefits of Data Visualization Uploads:</p>
          <ul className="dark:text-gray-300">
            <li class='mt-1'>
              <strong>Enhanced Communication:</strong> Data visualizations offer a powerful means of communication.
              By presenting complex information in a visual format, contributors can convey their findings and insights more effectively, enabling better understanding among viewers.
            </li>
            <li class='mt-1'>
              <strong>Improved Data Exploration:</strong> Visualizations allow users to explore data interactively.
              Viewers can manipulate charts, graphs, or other visual elements to gain deeper insights and uncover patterns or trends that might be less apparent in raw data.
            </li>
            <li class='mt-1'>
              <strong>Engaging Presentations:</strong> Visualizations help make presentations more engaging and captivating.
              By using visually appealing charts, diagrams, or interactive maps, contributors can capture the attention of their audience and communicate their message with greater impact.
            </li>
          </ul>

          <p class='font-medium text-lg text-center mt-3 dark:text-white'>Best Practices for Data Visualization Uploads:</p>
          <ul className="dark:text-gray-300">
            <li class='mt-1'>
              <strong>Data Accuracy:</strong> Ensure that the uploaded data is accurate, reliable, and up-to-date.
              Visualizations should be based on trustworthy information to maintain credibility and validity.
            </li>
            <li class='mt-1'>
              <strong>Clarity and Simplicity:</strong> Strive for clear and concise visualizations that are easy to understand.
              Avoid cluttering the visualization with excessive elements or complex designs that might confuse viewers.
            </li>
            <li class='mt-1'>
              <strong>Appropriate Visualization Type:</strong> Choose the visualization type that best suits the data and the intended message.
              Different types, such as bar charts, line graphs, pie charts, or heatmaps, serve different purposes, so select the one that effectively represents the information.
            </li>
            <li class='mt-1'>
              <strong>Accessibility:</strong> Consider accessibility standards when creating visualizations.
              Ensure that the visualization is legible and understandable for individuals with visual impairments, and provide alternative text or descriptions where necessary.
            </li>
          </ul>

          <p class='font-medium text-lg text-center mt-3 dark:text-white'>Key Takeaways:</p>
          <p class='mt-1 dark:text-gray-300'>
            Data visualization uploads offer a powerful way to present information in a visually appealing and easily understandable format.
            By following the guidelines outlined in this information page, contributors can create effective visualizations that enhance communication, facilitate data exploration, and engage their audience.
            Remember to select the appropriate file format, provide accurate information, and make the visualization accessible to a wide range of users.
          </p>
        </div>
      </div>
    </>
  )
}
